import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { App } from 'src/app/modules/shared/models/app.model';
import { AppSelectorComponent } from 'src/app/modules/shared/components/app-selector/app-selector.component';
import { SectionConfigModel } from '../../../models/section-configuration.model';

@Component({
    selector: 'apps-data-filter',
    templateUrl: 'apps-data-filter.component.html',
    styleUrls: ['apps-data-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppDataFilterComponent implements OnInit {
  @Input() parentFormGroup: FormGroup;
  @Input() sectionConfig: SectionConfigModel;
  @ViewChild('appSelector') appSelector: AppSelectorComponent;

  showAppSelector: boolean = false;
  newApp: App;
  sectionApps: App[] = [];

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.addControls();
  }

  private addControls(): void {
    this.parentFormGroup.addControl('appIds', this.fb.array(this.sectionConfig.filter.appIds ?? []));
  }

}
